module.exports = __webpack_public_path__ + "static/media/base-logo.d5448fe9.svg";